import { byPrefixAndName } from '@awesome.me/kit-f16c5d7bca/icons'
import { Box, Grid, GridItem, Heading, Skeleton, Text } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { DashboardCard } from './Dashboard.DashboardCard'

const ErrorIcon = ({ count = 0 }) => {
  if (count === 0)
    return (
      <Box color="green.500" display="inline" mr={2}>
        <FontAwesomeIcon icon={byPrefixAndName['fas']['circle-check']} />
      </Box>
    )

  return (
    <Box color="red.500" display="inline" mr={2}>
      <FontAwesomeIcon icon={byPrefixAndName['fas']['circle-exclamation']} />
    </Box>
  )
}

ErrorIcon.propTypes = { count: PropTypes.number }

export default function DashboardOrganization() {
  const history = useHistory()

  /** @type {number} */
  const orderErrors = useSelector(state => state.order_errors_count)
  /** @type {number} */
  const asyncErrors = useSelector(state => state.logs_error)

  return (
    <Grid templateColumns={{ base: 'repeat(3, 1fr)', md: 'repeat(6, 1fr)' }} gap={8} rowGap={16}>
      <GridItem colSpan={3} cursor="pointer" onClick={() => history.push('/orders/errors')}>
        <DashboardCard>
          <Skeleton isLoaded={typeof orderErrors === 'number'}>
            <Text>
              <ErrorIcon count={orderErrors} />
              {orderErrors}
            </Text>
            <Heading as="h6" size="xs">
              Order Errors
            </Heading>
          </Skeleton>
        </DashboardCard>
      </GridItem>
      <GridItem colSpan={3} cursor="pointer" onClick={() => history.push('/async_error_logs')}>
        <DashboardCard>
          <Skeleton isLoaded={typeof orderErrors === 'number'}>
            <Text>
              <ErrorIcon count={asyncErrors} />
              {asyncErrors}
            </Text>
            <Heading as="h6" size="xs">
              General Errors
            </Heading>
          </Skeleton>
        </DashboardCard>
      </GridItem>
    </Grid>
  )
}
